import React from "react";
import PageLayout from "../../components/Clearith/PageLayout";
import ContactContent from "../../components/Clearith/ContactContent";

const ContactPage: React.FC = () => (
  <PageLayout title="Contact" breadcrumb="Contact">
    <ContactContent />
  </PageLayout>
);

export default ContactPage;
